/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ExternalOAuthServer = {
  /**
   * The exact HTTPS issuer clients use for provider-hosted RFC 8414 discovery. Exactly one of authorization_server_issuer and metadata is present; changing modes may require clients to register or authenticate again.
   */
  authorizationServerIssuer?: string | undefined;
  /**
   * When the external OAuth server was created.
   */
  createdAt: Date;
  /**
   * The ID of the external OAuth server
   */
  id: string;
  /**
   * The validated RFC 8414 metadata Speakeasy hosts in compatibility mode. Exactly one of metadata and authorization_server_issuer is present.
   */
  metadata?: any | undefined;
  /**
   * The project ID this external OAuth server belongs to
   */
  projectId: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
  /**
   * When the external OAuth server was last updated.
   */
  updatedAt: Date;
};

/** @internal */
export const ExternalOAuthServer$inboundSchema: z.ZodMiniType<
  ExternalOAuthServer,
  unknown
> = z.pipe(
  z.object({
    authorization_server_issuer: z.optional(z.string()),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    metadata: z.optional(z.any()),
    project_id: z.string(),
    slug: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "authorization_server_issuer": "authorizationServerIssuer",
      "created_at": "createdAt",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function externalOAuthServerFromJSON(
  jsonString: string,
): SafeParseResult<ExternalOAuthServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalOAuthServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalOAuthServer' from JSON`,
  );
}
